export const TaskLinkNotificationMethod = {
    Sms: 'sms',
    Whatsapp: 'whatsapp',

    all() {
        return [
            {
                value: TaskLinkNotificationMethod.Sms,
                translationKey: 'settings.on-board.users.form.task-link-notification-method-sms'
            },
            {
                value: TaskLinkNotificationMethod.Whatsapp,
                translationKey: 'settings.on-board.users.form.task-link-notification-method-whatsapp'
            },
        ];
    }
}
